module.exports = __webpack_public_path__ + "static/img/xiazaijietu.156fdb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/xiazaijietu.png
// module id = Y6wa
// module chunks = 24